/* eslint-disable react/style-prop-object */
/* eslint-disable max-len */
import { FC, useState } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Button, Card, CardContent, Container, Snackbar, TextField, useMediaQuery, useTheme } from "@mui/material";
import classes from "./style";
import userService from "services/userService";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

const ReinitPassword: FC<{}> = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const token = searchParams.get('access')?.replaceAll(' ', '+');
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();

  const [email, setEmail] = useState<string>();
  const [emailError, setEmailError] = useState<string | undefined>();
  const [snackMessage, setSnack] = useState<string | undefined>(undefined);

  const [password, setPassword] = useState<string>();
  const [confirmation, setConfirmation] = useState<string>();
  const [passwordError, setPasswordError] = useState<string | undefined>();
  const [confirmationError, setConfirmationError] = useState<string | undefined>();

  const reinit = async () => {
    setEmailError(undefined);
    setPasswordError(undefined);
    setConfirmationError(undefined);

    if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email)) {
      setEmailError("L'adresse email est invalide.");
      return;
    }

    if (!/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/.test(password)) {
      setPasswordError("Le mot de passe doit contenir au moins une lettre majuscule, une lettre minuscule et un chiffre");
      return;
    }

    if (password != confirmation) {
      setConfirmationError("Les mots de passe ne sont pas identiques.");
      return;
    }

    try {
      await userService.reinitPassword(email, password, token);
      setSnack('Mot de passe changé avec succès.');
    } catch {
      setSnack("Une erreur s'est produite, veuillez contacter un administrateur.");
    }
    navigate('/');
  }

  return (<>
    <Container disableGutters maxWidth={false} sx={classes.authContainer}>
      <Box sx={{ width: isSm ? '80%' : (isMd ? '60%' : null) }}>
        <Card sx={{ ...classes.card, borderTopLeftRadius: "15px !important", position: "relative" }}>
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
            }}
          >
            <Box sx={{ mt: 2 }}>
              <Typography sx={classes.label}>Email</Typography>
              <TextField id="outlined-basic" label="Email" value={email} variant="outlined" sx={{ my: 2, width: '100%' }}
                onChange={(e) => setEmail(e.target.value!)} error={emailError ? true : false} helperText={emailError} fullWidth />

              <Typography sx={classes.label}>Mot de passe</Typography>
              <TextField id="outlined-basic" label="Mot de passe" value={password} variant="outlined" type='password' sx={{ my: 2, width: '100%' }}
                onChange={(e) => setPassword(e.target.value!)} error={passwordError ? true : false} helperText={passwordError}
                inputProps={{
                  autocomplete: 'new-password',
                  form: {
                    autocomplete: 'off',
                  },
                }} autoComplete="false" />

              <Typography sx={classes.label}>Confirmation du mot de passe</Typography>
              <TextField id="outlined-basic" label="Confirmation du mot de passe" value={confirmation} type='password' variant="outlined" sx={{ my: 2, width: '100%' }}
                onChange={(e) => setConfirmation(e.target.value!)} error={confirmationError ? true : false} helperText={confirmationError}
                inputProps={{
                  autocomplete: 'new-password',
                  form: {
                    autocomplete: 'off',
                  },
                }} autoComplete="false" />

            </Box>
            <Box sx={{ my: 2, display: 'flex', justifyContent: 'center' }}>
              <Button variant="contained" type="submit" sx={{ mr: 2 }} onClick={() => reinit()}>
                Changer le mot de passe
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container>

    <Snackbar
      open={snackMessage !== undefined ? true : false}
      autoHideDuration={5000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      onClose={() => setSnack(undefined)}
      message={snackMessage} />
  </>
  );
};

export default ReinitPassword;
